module.exports = __webpack_public_path__ + "img/cg1.2c2e409d.jpg";